<template>
  <div class="all-teams-wrap" v-if="list && list.length !== 0" :class="{'with-time': showTime}">
    <div v-if="showTime" class="time-row">
      <div class="label-box" style="margin-right: 0.5vw">
        <span class="label-shadow">开始时间: {{ info.startAt | time }}</span>
        <span class="label-text">开始时间: {{ info.startAt | time }}</span>
      </div>
      <div class="label-box">
        <span class="label-shadow">结束时间: {{ info.endAt | time }}</span>
        <span class="label-text">结束时间: {{ info.endAt | time }}</span>
      </div>
    </div>
    <!-- 所有队伍 -->
    <ul class="allTeams">
      <li
          v-for="(team, key, index) in list"
          :key="key"
          @click="handleQuiz(info, team, team, index)"
      >
        <div class="icon-bg">
          <div class="name">
            <div class="label-box">
              <span class="label-shadow">{{ team.name ? team.name : '-' }}</span>
              <span class="label-text">{{ team.name ? team.name : '-' }}</span>
            </div>
          </div>
          <div class="icon">
            <div
                class="head"
                :style="{
              'background-image': `url(${team.avatar ? team.avatar : ''})`,
            }"
            ></div>
            <div class="frame"></div>
          </div>
        </div>

        <div class="info">
          <div class="label-box odd">
            <span class="label-shadow">赔率 {{ team.lossRate ? team.lossRate : '0' }}</span>
            <span class="label-text">赔率 {{ team.lossRate ? team.lossRate : '0' }}</span>
          </div>
          <div class="label-box rating">
            <span class="label-shadow">支持率 {{ team?.popularity ? Number(team.popularity * 100).toFixed(0) : '0' }} %</span>
            <span class="label-text">支持率 {{ team?.popularity ? Number(team.popularity * 100).toFixed(0) : '0' }} %</span>
          </div>
        </div>
      </li>
      <li
          v-for="holder in list.length % 6 == 0 ? 0 : 6 - (list.length % 6)"
          :key="`hoder-${holder}`"
          :style="{ opacity: 0 }"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  inject: ['handleQuiz'],
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showTime() {
      return this.info.answers.length === 0;
    },
  },
  filters: {
    time: (val) => {
      let dateZh = ["日", "一", "二", "三", "四", "五", "六"];
      let date = new Date(val);
      // 月/日
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = date.getDate();
      day = day < 10 ? "0" + day : day;
      // 小时/分钟
      let hour = date.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let min = date.getMinutes();
      min = min < 10 ? "0" + min : min;

      // return `${month}/${day}(周${dateZh[date.getDay()]}) ${hour}:${min} 截止`;
      return ` ${hour}:${min} `;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/quiz/type/allTeams.scss';
</style>